module.exports = __webpack_public_path__ + "img/management.ab955ba8.svg";